(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  const header = document.querySelector('.site-header');
  const hero = document.querySelector('main > .shopify-section:first-child .hero, main > .shopify-section:first-child .collection-hero');
  if (hero) document.body.classList.add('has-master-hero');
  let tick = false;
  const update = () => { header?.classList.toggle('is-scrolled', scrollY >= 80); tick = false; };
  addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(update); } }, {passive:true}); update();
  const button = document.querySelector('[data-motion-toggle]');
  let paused = false;
  try { paused = sessionStorage.getItem('cicada-motion-paused') === 'true'; } catch (_) {}
  const motion = () => { root.classList.toggle('motion-paused',paused || reduce.matches); if(button){button.textContent=paused?'Enable motion':'Pause motion';button.setAttribute('aria-pressed',String(paused));} if(paused || reduce.matches) document.getAnimations().forEach(a=>a.cancel()); };
  button?.addEventListener('click',()=>{paused=!paused;try{sessionStorage.setItem('cicada-motion-paused',String(paused));}catch(_){}motion();});reduce.addEventListener('change',motion);motion();
  const observer = new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    observer.unobserve(entry.target);
    if(paused || reduce.matches)return;
    const items=entry.target.querySelectorAll('h1,h2,.rte,.eyebrow');
    items.forEach((el,i)=>el.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:600,delay:Math.min(i,4)*100,easing:'ease-out'}));
  }),{threshold:.08});
  document.querySelectorAll('main section,main .editorial-integrated').forEach(el=>observer.observe(el));
  document.querySelectorAll('[data-mobile-menu]').forEach(menu=>{
    menu.addEventListener('keydown',event=>{
      if(event.key!=='Tab'||!menu.open)return;
      const links=[...menu.querySelectorAll('summary,a,button,input')].filter(el=>el.getClientRects().length);
      const first=links[0],last=links.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
  });
})();
